import appConfig from '../config/appConfig.json';

// Form URL for free sample requests - use this across the website
export const FREE_SAMPLE_FORM_URL = appConfig.freeSampleFormUrl;

